<div class="p-mobile-friendly animate-fade-in min-h-screen">
  <div class="col-12 text-center mb-4">
    <h1 class="text-2xl md:text-3xl font-bold animate-slide-up">Verify Watermark</h1>
    <p class="text-color-secondary">Upload an image to verify its authenticity</p>
  </div>

  <div class="col-12 md:col-8 md:col-offset-2 lg:col-6 lg:col-offset-3">
    <div class="card-modern p-5">
      @if (email || timestamp) {
        <div class="text-center mb-4">
          <!-- Success badge for verified watermark -->
          <div class="check-status-badge success animate-scale-in mb-3">
            <i class="pi pi-check-circle text-5xl"></i>
          </div>
          <h2 class="text-2xl font-bold mb-3 text-green-600">Watermark Verified</h2>

          <div class="watermark-info">
            @if (email) {
              <div class="mb-2">
                <span class="text-color-secondary">Email:</span>
                <span class="font-semibold ml-2">{{ email }}</span>
              </div>
            }
            @if (timestamp) {
              <div class="mb-2">
                <span class="text-color-secondary">Timestamp:</span>
                <span class="font-semibold ml-2">{{ timestamp }}</span>
              </div>
            }
          </div>
        </div>
      }

      @if (message && !email && !timestamp) {
        <div class="text-center mb-4">
          <!-- Error badge for invalid watermark -->
          <div class="check-status-badge error animate-scale-in mb-3">
            <i class="pi pi-times-circle text-5xl"></i>
          </div>
          <h2 class="text-2xl font-bold mb-3 text-red-600">{{ message }}</h2>
        </div>
      }

      @if (!email && !timestamp && !message) {
        <div class="text-center mb-4">
          <!-- Info badge for initial state -->
          <div class="check-status-badge info animate-scale-in mb-3">
            <i class="pi pi-image text-5xl"></i>
          </div>
          <h2 class="text-xl font-bold mb-3">Upload an Image</h2>
          <p class="text-color-secondary">Select an image to check for watermark verification</p>
        </div>
      }

      <div class="upload-container">
        <p-fileUpload
          (onUpload)="onUpload($event)"
          [url]="getUploadUrl()"
          chooseLabel="Choose Image"
          mode="basic"
          name="media"
          accept="image/*"
          [auto]="true"
          class="w-full"
        ></p-fileUpload>
      </div>

      @if (email || timestamp) {
        <div class="flex justify-content-center mt-4">
          <p-button
            (onClick)="resetVerification()"
            label="Check Another Image"
            icon="pi pi-refresh"
            class="p-button-lg btn-modern"
          ></p-button>
        </div>
      }
    </div>
  </div>

  @if (operationInProgress) {
    <div class="col-12 md:col-8 md:col-offset-2 lg:col-6 lg:col-offset-3 mt-3">
      <p-progressBar [style]="{ height: '6px' }" mode="indeterminate"></p-progressBar>
    </div>
  }
</div>
